// @ts-nocheck
import { Address } from 'src/careflow/ph-core/fhir-client/resources';
import { createWrapper } from 'src/careflow/ph-core/fhir-client/fhir-react/base';
import { getNPIFromIdentifier, getTelecomValues, formatUSAddress } from "src/utils/fhir";

export const OrganizationWrapper = createWrapper('Organization', (organization) => ({
  
  getPrimaryAddress(): Address | null {
    let mainAddress = null;
    if (organization.address && organization.address?.length > 0) {
      mainAddress = organization.address[0];
    }
    return mainAddress;
  },
  getPrimaryAddressFormatted(): string | null {
    const mainAddress = this.getPrimaryAddress();
    return mainAddress
      ? `${mainAddress?.city}, ${mainAddress?.state}, ${mainAddress?.postalCode}`
      : null;
  },
  getNPI: (): string => getNPIFromIdentifier(organization?.identifier ?? []),
  getPhones: (): string[] =>
    getTelecomValues("phone", organization?.telecom ?? []),
  getEmails: (): string[] =>
    getTelecomValues("email", organization?.telecom ?? []),
  getFormattedAddresses: (): string[] =>
    organization?.address?.map?.((address) => formatUSAddress(address)) ?? [],
  getType: (): string => {
    const { text, coding } =
      organization?.type?.find?.(
        ({ text, coding }) => !!coding?.[0]?.display || !!text
      ) ?? {};
    return (text || coding?.[0]?.display) ?? "";
  },
  getPrimaryContactPhone(): string | null {
    const mainPhone = getTelecomValues("phone", organization?.contact?.telecom ?? []);
    return mainPhone?.length > 0
      ? mainPhone?.[0]
      : null;
  },
  getPrimaryContactEmail(): string | null {
    const mainEmail = getTelecomValues("email", organization?.contact?.telecom ?? []);
    return mainEmail?.length > 0
      ? mainEmail?.[0]
      : null;
  },
}));
export type WrappedOrganization = ReturnType<typeof OrganizationWrapper>;
